import React from 'react';
import { Button, Col, Row } from 'antd';
import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EditIcon } from '@/assets/icons/edit.svg';
import Process from '@/components/common/process/Process';

const ImageCutoutUploadSuccessRender = ({
  imageCutoutObj,
  submitting,
  handleClose,
  handleSubmit,
  handleDownload,
  handleShowEditor,
  cancelProcessCallBack,
  pageType,
  base64,
  calWidth,
  calheight,
  preBase
}) => {
  const { t } = useTranslation(['imageCutout', 'common']);

  return (
    <div className='work-cont'>
      {!submitting ? <CloseCircleOutlined className='close-btn' onClick={handleClose} /> : null}

      <Row gutter={[24, 0]} style={{ marginBottom: 40 }} className='image-list'>
        <Col style={{ margin: 'auto' }}>
          <div className='image-cont'>
            {/* <img src={imageCutoutObj.fileurl} alt='HitPaw cutout' /> */}
            <img src={base64} alt='HitPaw cutout' style={{width:calWidth,height:calheight}}/>
          </div>
        </Col>
        {submitting ? (
          <Col>
            <div className='remove-cont' style={{width:calWidth,height:calheight}}>
              <Process
                type='square'
                visible
                processText={t('Removing')}
                hideCancelText
                showProcessText
                cancelProcessCallBack={cancelProcessCallBack}
              />
            </div>
          </Col>
        ) : null}
        {imageCutoutObj.cutoutfileurl ? (
          <Col>
            <div className='image-cont transparent'>
              <Button type='primary' icon={<EditIcon />} onClick={handleShowEditor}>
                {t('Edit')}
              </Button>
              <img src={preBase} alt='HitPaw cutout' style={{width:calWidth,height:calheight}}/>
            </div>
          </Col>
        ) : null}
      </Row>
      {imageCutoutObj.cutoutfileurl ? (
        <Button type='primary' onClick={handleDownload}>
          {t('common:Download')}
        </Button>
      ) : !submitting ? (
        <Button type='primary' onClick={handleSubmit}>
          {t(`imageCutout:${pageType}:submitBtn`)}
        </Button>
      ) : null}
      {imageCutoutObj.cutoutfileurl ? (
        <p className='download-tips'>
          <InfoCircleOutlined /> {t("common:Don't forget to download your file, it will be deleted after 24 hours.")}
        </p>
      ) : null}
    </div>
  );
};

export default ImageCutoutUploadSuccessRender;
